import googleCalendarImage from '../img/calendarIcons/google-calendar.png';
import appleCalendarImage from '../img/calendarIcons/apple-calendar.png';
import outlookImage from '../img/calendarIcons/outlook.png';
import office365Image from '../img/calendarIcons/office365.png';

export const CALENDAR_OPTIONS = [
  {
    serviceName: 'google',
    title: 'Google',
    subtitle: '',
    image: googleCalendarImage,
    altText: 'google-calendar',
  },
  {
    serviceName: 'iCloud',
    title: 'iCloud',
    subtitle: '',
    image: appleCalendarImage,
    altText: 'apple-calendar',
  },
  {
    serviceName: 'outlook',
    title: 'Outlook',
    subtitle: 'Personal',
    image: outlookImage,
    altText: 'outlook',
  },
  {
    serviceName: 'office365',
    title: 'Office 365',
    subtitle: 'Business',
    image: office365Image,
    altText: 'office-365',
  },
] as const;

export const SALES_EMAIL = 'sales@brokerbay.com';
export const SUPPORT_EMAIL = 'support@brokerbay.com';
export const UPGRADE_EMAIL = 'upgrade@brokerbay.com';
export const CONTACT_SUPPORT_LINK =
  'https://brokerbay.zendesk.com/hc/en-us/requests/new';

// Should be identical to regex on gatekeeper
export const PASSWORD_REGEX = '(?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).{8,}';

export const OBJECT_ID_REGEX = '[a-f\\d]{24}';

export const DATE_ONLY_REGEX = /^\d{4}(-\d{2}){2}$/;

export const CHAT_SESSION_STORAGE_KEYS = [
  'messageDrafts',
  'messageDraftsForNewConvo',
  'chatInstances',
  'activeChatInstance',
  'newConvoSelections',
  'assumedChatInstances',
  'assumedBrokerageId',
];

export const DASHBOARD_LISTING_STORAGE_KEYS = {
  status: 'dashboard:listing:status',
  availability: 'dashboard:listing:availability',
} as const;

export const SHOWINGS_CALENDAR_STORAGE_KEYS = {
  buyerStatuses: 'showings:buyer:statuses',
  buyerPendingStatus: 'showings:buyer:pendingStatus',
  listingStatuses: 'showings:listing:statuses',
  listingPendingStatus: 'showings:listing:pendingStatus',
  individualListingStatuses: 'showings:individualListing:statuses',
  individualListingPendingStatus: 'showings:individualListing:pendingStatus',
} as const;

export const MLS_STAFF_USERS_STORAGE_KEYS = {
  userTypesFilter: 'mls:users:userTypesFilter',
  userSubRolesFilter: 'mls:users:userSubRolesFilter',
  supraStatusesFilter: 'mls:users:supraStatusesFilter',
  supraTypesFilter: 'mls:users:userSubscriptionTypesFilter',
  userStatusesFilter: 'mls:users:userStatusesFilter',
  answeringServiceTypesFilter: 'mls:users:answeringServiceTypesFilter',
  userCoopTypeFilter: 'mls:users:coopTypeFilter',
};

export const mobileBarRowHeight = 62;
// Use LayoutContext.topElementHeights over these when possible.
export const assumeBarMobileAssumedHeight = 50;
export const assumeBarMobileHeight = 25;

export const MAX_NOTICE_IN_MINUTES = 6000;
